export default __webpack_public_path__ + "static/media/plain-sticker-j.e7c28f6c.png";